module.exports = __webpack_public_path__ + "img/Flag_of_Croatia.f98c8989.svg";